const routes = [
    {
        path: "/wdc/course/list",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    }
]

export default routes;
